module.exports = __webpack_public_path__ + "static/b075064657dffe51cb2b8ad5aa606b6056a8ac4d39229de040d6f8575770bdcf-f4b958f3ed4b50158dabd76f85ae1de2.jpeg";